module.exports = __webpack_public_path__ + "static/media/loader2.b11a6b06.gif";